<template>
<v-container mt-4 class="applicationContainer justify-content-center" >
  <!-- <v-flex md3 class="sidebar">
    <aside> -->
      <!-- NOTE:
      uncomment the following lines to render sidebar
      when route params are properly passed
      and
      computed properties are set-->

      <!-- <span class="patient_profile">
        <h4>{{ptName}}</h4>
        <h5>{{ptAge}}/{{ptGender}}
          <span v-if='ptPlace === "undefined" || ptPlace ===  "null" '></span>
      <span v-else>, {{ptPlace}}</span>
      </h5>
      </span>
      <ul>
        <li class="active">
          <router-link :to="{name: 'vitalsPost', params: {status:`${vitalsStatus}`,appId: `${appId}`,ptId: `${ptId}`}}">Vitals</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'prescription', params: {appId: `${appId}`,ptId: `${ptId}`} }">Prescriptions</router-link>
        </li> -->

        <!-- end of sidebar ->
      </ul> -->
    <!-- </aside>
  </v-flex> -->
  <v-flex md9 justify="center">
    <!-- <h1>All patient module goes here</h1> -->
    <el-row>
      <!-- <el-input
        placeholder="Search Patients"
        v-model="searchText"
        class="mb-4"
        @blur="sample()"
        clearable>
      </el-input> -->

    <el-autocomplete
    placeholder="Search"
    class="col-12 mb-3"
    :clear="clearSearch"
    v-model="searchText"
    clearable
    ref="box"
    @focus="showFilter=true;active=true"
    @blur="searchBlur"

    popper-class='d-none'
    :trigger-on-focus="false"
    :fetchSuggestions="fetchSuggestions"
    >
    <i
    class="el-icon-search  el-input__icon"
    slot="prefix">
  </i>

</el-autocomplete>

</el-row>

    <el-row>
   <div class="el-row" v-infinite-scroll="loadMore" :infinite-scroll-disabled="busy" infinite-scroll-distance="30">

  <el-col :span="24" v-for="(data, index) in this.allPatients" :key="index" >
    <el-card v-loading="index+1 === allPatients.length ? fullscreenLoading:false" :body-style="{ padding: '0px' }" shadow="never">
      <v-container class="heightInitial">
      <v-flex md9 class="cursor-pointer">
      <!-- <div style="padding: 14px;"> -->
        <div>
       <div class="media" @click="PatientProfile(index)">
                  <div class="media-left">
                      <avatar
                        :username="data.name"
                        :size="30">
                      </avatar>
                  </div>
                  <div class="media-content">
                      {{ data.name }}
                      <br>
                      <small style="color: dimgray">
                           {{ data.number }}
                      </small>
                  </div>
              </div>
      </div>
      </v-flex>
      <v-flex md3 class="d-flex justify-content-end align-items-center">
        <!-- <el-button v-if="data.queue_state !== 'In Queue'" @click.native="fetchPatient(index)" type="primary" plain>Appointment</el-button>
        <el-button v-if="data.queue_state === 'In Queue'"  type="info" disabled>Added to Queue</el-button> -->

<el-button v-if="chkState(data.doctors) == false" @click.native="fetchPatient(index)" type="primary" plain>Appointment</el-button>
        <el-button v-else="chkState(data.doctors) == true"  type="info" disabled>Added to Queue</el-button>
      </v-flex>
      </v-container>
    </el-card>
  </el-col>
  <el-col v-if="this.allPatients.length === 0">
        Sorry No Patients Found
  </el-col>
   </div>
</el-row>

<v-dialog max-width="800px" v-model="dialogVisible">
  <v-flex xs12>
    <v-card class="the--card">
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn icon @click.native="dialogVisible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <ExistingRegistration :selectedPatients="selectedPatient"></ExistingRegistration>
    </v-card>
  </v-flex xs12>
</v-dialog>
<v-dialog max-width="800px" v-model="dialogProfileVisible" :lock-scroll="true" :scrollable="true" >
  <v-flex xs12>
    <v-card class="the--card">
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn icon @click.native="dialogProfileVisible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <ViewProfile :manageProfile="!dialogProfileVisible" :selectedPatients="selectedPatient"></ViewProfile>
    </v-card>
  </v-flex xs12>
</v-dialog>

    <!-- DR-139 -->
    <!-- Look at ExistingRegistration.vue for implementation -->
    <!-- click on 'Add Patient' button
    and search in modal to see how it works -->
  </v-flex>
</v-container>

</template>

<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import { api , jQuery401Callback } from '../api.js';
import { axios, post } from 'axios';
import ExistingRegistration from './ExistingRegistration';
import Avatar from 'vue-avatar';
import ViewProfile from './viewProfile';
export default {
  userName: '',
  components: {
    ExistingRegistration,
    Avatar,
    ViewProfile
    // NOTE: don't forget to add components here after import
    // sample in next line
    // VueGoogleAutocomplete
  },
  beforeRouteLeave: (to, from, next) => {
    // NOTE: add any action to be performed before leaving the route here
    // the next() is important
    // so add everything before next()
    // sample in next line
    // console.log("Loggin before leaving route");
    next();
  },
  data() {
    return {
      snackbar: false,
      snackbarColor: '',
      allPatients: [
        {
          name: ''
        }
      ],
      selectedPatient: {},
      dialogVisible: false,
      dialogProfileVisible: false,
      fullscreenLoading: true,
      mode: '',
      fetchPage: true,
      page: 1,
      busy: false,
      currentDate: new Date(),
      timeout: 6000,
      searchText: '',
      snackbarText: "Hello, I'm a snackbar",
      doctors: [],
      chkQueueState: false,
      doctor_id: ''
    };
  },
  mounted() {
    this.fetchAllPatients('', true);
    // NOTE: add actions to be performed on-mount
  },
  watch: {
    dialogVisible(val) {
      console.log(val);
      if (!val) {
        return;
      }
      //this.searchByVal(val);
    }
  },
  computed: {
    displayData() {
      if (!this.allPatients || this.allPatients.length === 0) return [];
      // var index = this.handleCurrentChange * 3 - 3;
      // return this.allPatients.slice(index, index + 3);
    }
  },
  methods: {
    chkState(data){
 let doc_id=parseInt(localStorage.doctor_id)
      //  console.log("chkstatedata", data)
      //  console.log("doc_id", doc_id)
 let arrayDes=data
 let find = arrayDes.find((item)=> {
   return item.doctor_id === doc_id
 })
 if(find.queue_state == "In Queue") return true
 else return false
},

    say: function(message) {
      alert(message);
    },
    // NOTE: all functions go here
    loadMore: function() {
      this.busy = true;
      setTimeout(() => {
        if (this.fetchPage) {
          this.page++;
          this.fetchAllPatients(this.searchText, false);
          this.busy = false;
        }
      }, 100);
    },

    PatientProfile(index) {
      this.dialogProfileVisible = true;
      console.log(this.allPatients);
      this.selectedPatient = this.allPatients[index];
    },

    searchBlur() {
      setTimeout(() => {
        console.log(this.searchText);
        this.fetchSuggestions();
      }, 500);
    },
    clearSearch() {
      console.log('clearSearch called');
      this.fetchAllPatients('', true);
    },
    fetchSuggestions() {
      this.page = 1;
      this.fetchPage = true;
      this.busy = false;
      this.fullscreenLoading = true;

      // this.allPatients = [];

      this.fetchAllPatients(this.searchText, true);
    },
    fetchPatient(index) {
      this.selectedPatient = this.allPatients[index];
      this.dialogVisible = true;
    },
    fetchAllPatients(searchText, clearData) {
      let token = localStorage.getItem('token', this.token);
      this.doctors = JSON.parse(localStorage.getItem("doctors"));
      console.log("doctors", this.doctors)
      let person_search =
        (this.doctors.length > 1)
          ? "/v3/person_search?search="
          : "/person_search?search=";
      $.ajax({
        url: `${api}${person_search}${searchText}&page_no=${this.page}`,
        type: 'GET',
        headers: {
          token: token
        },
        error: jQuery401Callback
      }).then(res => {
        console.log("res.details", res.details)
        console.log("localStorage.doctor_id", localStorage.doctor_id)
        let response = res.details;
        this.allPatients = res.details.allPatients

        this.allPatients = clearData ? [] : this.allPatients;
        this.allPatients =
          response.length > 0
            ? [...this.allPatients, ...response]
            : [...this.allPatients];

            console.log("this.allPatients",this.allPatients)
        this.fetchPage = response.length === 0 ? false : true;

        this.fullscreenLoading = this.fetchPage ? true : false;
        if (response.length < 14) {
          this.fullscreenLoading = false;
        }
        // if (response.length > 0) {
        //   this.allPatients = [...this.allPatients, ...response];
        // } else {
        //   this.allPatients = [];
        // }
      });
    }
  }
};
</script>
<style scoped>
.container {
  /* height: 100vh; */
  display: flex;
}
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}
.applicationContainer > div {
  /* height: calc(100vh - 72px); */
  height: calc(100vh - 72px - 40px);
  overflow: scroll;
}
.heightInitial {
  height: initial;
  width: initial;
}
.d-flex {
  display: flex;
}
.justify-content-end {
  justify-content: flex-end;
}
.align-items-center {
  align-items: center;
}
.justify-content-center {
  justify-content: center;
}
.applicationContainer .el-card {
  border-radius: 0;
  border: 0;
  border-bottom: 1px solid #ebeef5;
}

.the--card .layout:first-child {
  padding-right: 1rem;
  text-align: right;
}
.the--card .layout:last-child {
  padding: 1rem;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
<style>
.d-none {
  display: none;
}
.col-12 {
  width: 100%;
}
.dialog--scrollable {
  overflow: scroll !important;
}
</style>



// WEBPACK FOOTER //
// src/components/allPatients.vue